module.exports = __webpack_public_path__ + "static/media/online-time-attendance.e91ba43c.png";